<template>
<b-card title="Detalhes da Assinatura Atual">
  <b-card-text>
    <b-container>
      <b-row>
        <b-col> <span>Plano:</span></b-col>
        <b-col class="text-right"> {{ last_subscription.name}}</b-col>
      </b-row>
      <b-row>
        <b-col> <span>Valor:</span></b-col>
        <b-col class="text-right"> R$ {{ last_subscription.value | decimal}}</b-col>
      </b-row>
      <b-row>
        <b-col><span>Inicio: </span> </b-col>
        <b-col class="text-right">{{last_subscription.start_at | dateBr}}</b-col>
      </b-row>
      <b-row>
        <b-col><span>Final: </span></b-col>
        <b-col class="text-right">{{last_subscription.finish_at | dateBr}}</b-col>
      </b-row>
       <b-row class="text-center">
          <b-col>
            <b-button
              size="sm" @click="$emit('renovate', renovePlan)" variant="success"
            >
              <i class="fas fa-sync" /> Renovar Assinatura
            </b-button>
          </b-col>
        </b-row>


    </b-container>
  </b-card-text>
</b-card>
</template>

<script>
export default {

  data: function () {
    return {
      renovePlan: {
        type: 'renovate',
        last_plan: {},
      }
    };
  },

  created() {
    this.setPlanData()
  },
  computed: {

    last_subscription() {
      return this.$store.state.subscribe;
    },
  },

  methods: {
    setPlanData() {
      this.renovePlan.last_plan = this.last_subscription;
    }
  }
};
</script>

<style>
</style>
